import axios from "axios";
import {useQuoteStore} from "@/stores/QuoteStore";
import {useCoreStore} from "@/stores/CoreStore";

export default class QuoteBuilderService {
    constructor(pageData) {
        const coreStore = useCoreStore();
        this.baseUrl = process.env.VUE_APP_API_URL
        this.pageData = pageData
        this.uuid = pageData.uuid

        // Create Axios instance with base URL
        this.axios = axios.create({
            baseURL: this.baseUrl,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'Authorization': 'Bearer ' + coreStore.pageData.apiKey
            },
        });

    }

    async init() {
        let response = await this.axios.get('/api/quote-builder/core/settings')
        const quoteStore = useQuoteStore();
        const coreStore = useCoreStore();
        let responseData = response.data;
        quoteStore.setProducts(responseData.products)
        quoteStore.setSettings(responseData.settings)
        coreStore.settings = responseData.settings

    }

    async getQuote() {
        const quoteStore = useQuoteStore();
        let response = await this.axios.get('/api/quote-builder/quote/find/' + this.uuid)
        quoteStore.setQuoteObj(response.data.quote);
        quoteStore.setFrames(response.data.frames)
        quoteStore.setLoading(false)
    }

    async updateQuote (){
        const quoteStore = useQuoteStore();
        let response = await this.axios.post(
            '/api/quote-builder/quote/update/' + this.uuid,
            quoteStore.quoteObj
        )

        if (response.data) {
            return true;
        }

        return false;
    }

    async purchaseQuote() {
        let coreStore = useCoreStore()

        let response = await this.axios.get('/api/quote-builder/quote/purchase/' + this.uuid)
    }

    async deleteQuoteItem(itemId) {
        let response = await this.axios.delete('/api/quote-builder/quote/delete/' + this.uuid + '/' + itemId)
        this.getQuote();
        return true;
    }

    async updateQuoteItem(quoteItem, postData) {
        let response = await this.axios.post('/api/quote-builder/quote/update-item/' + quoteItem.uuid, postData)
    }

    async emailQuote(postData) {
        let response = await this.axios.post('/api/quote-builder/email/' + this.uuid , postData)
    }
}